<template>
    <div :key="goalsModeKey" v-show="!$store.getters.appLoading" class="planner">

      <Header title="Monthly Planner" />

        <vs-row vs-type="flex" vs-align="flex-end" class="mb-4 px-5" >
          <vs-col vs-w="10">

            <ul class="demo-alignment" v-if="!oneDreamTotal">
              <li v-for="dream in dreams" :key="`dream_${dream.id}`">
                    <vs-checkbox icon-pack="feather" icon="icon-compass" class="planner__dreams-checkbox"  v-model="selectedDreamIds" :vs-value="dream.id">{{dream.title}}</vs-checkbox>
              </li>
            </ul>
          </vs-col>

          <vs-col vs-type="flex" vs-justify="flex-end" vs-w="2">
            <PeriodToggle class="ml-2" />
          </vs-col>
        </vs-row>

      <vs-row>
      <vs-col vs-w="6" class="px-5">
        <div class="planner__goals-box-with-title">
          <BoxHeader :title="monthInWords" :count="goals.length">
          <AddNew title="" @addGoal="addGoalDialog(currentPeriod)"  />
        </BoxHeader>
        <draggable
          :list="goals"
          group="goals"
          key="this_month"
          handle=".vx-card__header"
          ghost-class="ghost-goal-planner"
          animation="0"
          class="planner__goals-box"
        >
          <template v-for="goal in goals">
              <Goal
                  :key="goal.id"
                  :goal="goal"
                  :showDream="!dreamMode"
                  :forceCollapsed="true"
                  :showProgressSlider="false"
                  class="vx-col w-full mb-2"
                  forceJustifyIcon
                  :compact="true"
                  @edit="editGoalDialog(goal)"
              />
          </template>
        </draggable>
        </div>


        <!-- box 2 -->
        <div class="planner__goals-box-with-title">
          <BoxHeader :title="nextMonthInWords" :count="nextMonthGoals.length">
            <AddNew title="" @addGoal="addGoalDialog(nextPeriod)"  />
          </BoxHeader>
          <draggable
            :list="nextMonthGoals"
            group="goals"
            key="nextMonth"
            handle=".vx-card__header"
            ghost-class="ghost-goal-planner"
            animation="0"
            class="planner__goals-box"
          >
            <template v-for="goal in nextMonthGoals">
                <Goal
                    :key="goal.id"
                    :goal="goal"
                    :showDream="!dreamMode"
                    :forceCollapsed="true"
                    :showProgressSlider="false"
                    class="vx-col w-full mb-2"
                    forceJustifyIcon
                    :compact="true"
                    @edit="editGoalDialog(goal)"
                />
            </template>
          </draggable>
        </div>


       <!-- box 3 -->
       <div class="planner__goals-box-with-title">
          <BoxHeader :title="nextNextMonthInWords" :count="nextNextMonthGoals.length">
            <AddNew title="" @addGoal="addGoalDialog(nextNextPeriod)"  />
          </BoxHeader>
          <draggable
            :list="nextNextMonthGoals"
            group="goals"
            key="nextNextMonth"
            handle=".vx-card__header"
            ghost-class="ghost-goal-planner"
            animation="0"
            class="planner__goals-box"
          >
            <template v-for="goal in nextNextMonthGoals">
                <Goal
                    :key="goal.id"
                    :goal="goal"
                    :showDream="!dreamMode"
                    :forceCollapsed="true"
                    :showProgressSlider="false"
                    class="vx-col w-full mb-2"
                    forceJustifyIcon
                    :compact="true"
                    @edit="editGoalDialog(goal)"
                />
            </template>
          </draggable>
        </div>
      </vs-col>

      <!-- Backlog -->
      <vs-col vs-w="6" v-if="notPlannedGoals" class="px-5">
        <div class="planner__goals-box-with-title">
          <BoxHeader title="Backlog (Brainstorming)">
            <AddNew title="" @addGoal="addGoalDialog(null)"  />
          </BoxHeader>

            <draggable
              :list="notPlannedGoals"
              group="goals"
              key="backlog"
              handle=".vx-card__header"
              ghost-class="ghost-goal-planner"
              animation="0"
              class="planner__goals-box backlog"
            >
              <template v-for="goal in notPlannedGoals">
                  <Goal
                      :key="goal.id"
                      :goal="goal"
                      :showDream="!dreamMode"
                      :forceCollapsed="true"
                      :showProgressSlider="false"
                      class="vx-col w-full mb-2"
                      forceJustifyIcon
                      :compact="true"
                      @edit="editGoalDialog(goal)"
                  />
              </template>
            </draggable>
        </div>

      </vs-col>
      </vs-row>

      <EditForm
          :editedEntity="editedEntity"
          :currentPeriod="dreamMode ? null : currentPeriod"
          :planningMode="planningMode"
          :dreamMode="dreamMode"
          @close="closeGoalDialog"
      />

    </div>
</template>
<script>
import _ from 'lodash'
import draggable from 'vuedraggable'
import AddNew from './AddNew'
import SelectButton from './SelectButton'
import EditForm from './EditForm'
import Select from './Select'
import AssignGoals from './AssignGoals'
import AddDropdown from './AddDropdown'
import Goal from './Goal'
import BoxHeader from './Planner/BoxHeader'
import GoalsPreviewPlanner from '../Preview/GoalsPreviewPlanner'
import NoGoalsInDream from '../Preview/NoGoalsInDream'
import PeriodToggle from '../Generic/PeriodToggle'
// import trackAnalytics from '@/helpers/trackAnalytics'
import { isPastPeriod, monthInWordsFormat, periodRelativeToCurrent, arePeriodsEqual } from '@/helpers/date'

export default {
  components: {
    draggable,
    AddNew,
    SelectButton,
    EditForm,
    Select,
    Goal,
    GoalsPreviewPlanner,
    PeriodToggle,
    AssignGoals,
    AddDropdown,
    NoGoalsInDream,
    BoxHeader,
  },
  props: {
    planningMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dreamMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    dream: {
      type: Object,
      required: false,
      default: () => null
    },
    openDialog: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    period: {
      type: Date,
      required: false,
      default: () => null,
    }
  },
  data () {
    return {
      editedEntity: null,
      goals: [],
      nextMonthGoals: [],
      nextNextMonthGoals: [],
      notPlannedGoals: [],
      plannedGoals: [],
      goalsLoading: false,
      goalsOrder: {},
      selecting: false,
      selectedDreamIds: []
    }
  },
  watch: {
    '$store.getters.allGoals': {
      immediate: true,
      handler () {
        this.loadGoals()
      }
    },
    '$store.getters.allDreams': {
      immediate: true,
      handler () {
        this.selectedDreamIds = _.map(this.$store.getters.allDreams, 'id')
      }
    },
    'currentPeriod': {
      immediate: false,
      handler () {
        this.loadGoals()
      }
    },
    'selectedDreamIds': {
      immediate: false,
      handler () {
        this.loadGoals()
      }
    },
    'goals': {
      immediate: false,
      handler (goals) { if (!this.goalsLoading) { this.checkAndUpdate(goals, this.currentPeriod) } }
    },
    'nextMonthGoals': {
      immediate: false,
      handler (goals) { if (!this.goalsLoading) { this.checkAndUpdate(goals, periodRelativeToCurrent(this.currentPeriod, 1)) } }
    },
    'nextNextMonthGoals': {
      immediate: false,
      handler (goals) { if (!this.goalsLoading) { this.checkAndUpdate(goals, periodRelativeToCurrent(this.currentPeriod, 2)) } }
    },
    'notPlannedGoals': {
      immediate: false,
      handler (goals) { if (!this.goalsLoading) { this.checkAndUpdate(goals, null) } }
    },
  },
  computed: {
    currentPeriod () {
      return this.$store.getters.currentPeriod
    },
    nextPeriod () {
      return periodRelativeToCurrent(this.currentPeriod, 1)
    },
    nextNextPeriod () {
      return periodRelativeToCurrent(this.currentPeriod, 2)
    },
    isCurrentPeriodPast () {
      return isPastPeriod(this.currentPeriod)
    },
    goalsPresent () {
      return _.size(this.goals)
    },
    noGoalsPresent () {
      return _.size(this.$store.getters.allGoals)
    },
    monthInWords () {
      return monthInWordsFormat(this.currentPeriod)
    },
    nextMonthInWords () {
      return monthInWordsFormat(this.nextPeriod)
    },
    nextNextMonthInWords () {
      return monthInWordsFormat(this.nextNextPeriod)
    },
    selectGoalEnabled () {
      return _.size(this.$store.getters.goalsWithoutPeriod)
    },
    goalsOrderKey () {
      return this.dreamMode ? 'orderDream' : 'orderPlan'
    },
    goalsModeKey () {
      return _.join([
        'goals',
        this.planningMode ? 'planning' : '!planning',
        this.dreamMode ? 'dreaming' : '!dreaming'
      ], '_')
    },
    dreams () {
      return this.$store.getters.allDreams
    },
    oneDreamTotal () {
      return this.dreams.length === 1
    },
    singleDreamId () {
      return this.selectedDreamIds.length === 1 ? this.selectedDreamIds[0] : null
    },
  },
  mounted () {
    this.loadGoals()
  },
  methods: {
    async loadGoals () {
      console.log('loading')
      this.goalsLoading = true

      this.goals = this.keepOrderBy(
        this.goals,
        this.filterByDream(this.$store.getters.goalsByPeriod(this.currentPeriod))
      )

      this.nextMonthGoals = this.keepOrderBy(
        this.nextMonthGoals,
        this.filterByDream(this.$store.getters.goalsByPeriod(periodRelativeToCurrent(this.currentPeriod, 1)))
      )

      this.nextNextMonthGoals = this.keepOrderBy(
        this.nextNextMonthGoals,
        this.filterByDream(this.$store.getters.goalsByPeriod(periodRelativeToCurrent(this.currentPeriod, 2)))
      )

      this.notPlannedGoals = this.keepOrderBy(
        this.notPlannedGoals,
        this.filterByDream(this.$store.getters.goalsWithoutPeriod)
      )

      setTimeout(() => { this.goalsLoading = false }, 500)
    },
    filterByDream (goals) {
      if (this.selectedDreamIds) {
        return goals.filter((goal) => _.includes(this.selectedDreamIds, goal.dreamId))
      } else {
        return goals
      }
    },
    keepOrderBy (originalArray, newArray) {
      return _.sortBy(
        newArray, (goal) => _.findIndex(originalArray, (g) => g.id === goal.id)
      )
    },
    addGoalDialog (period) {
      this.editedEntity = {
        period,
        dreamId: this.singleDreamId
      }
    },
    selectGoalDialog () {
      this.selecting = true
    },
    closeSelectDialog () {
      this.selecting = false
    },
    editGoalDialog (goal) {
      this.editedEntity = goal
    },
    closeGoalDialog () {
      this.editedEntity = null
    },
    checkAndUpdate (goals, period) {
      console.log('checking period', period)
      const goalToUpdate = _.find(goals, (goal) => !arePeriodsEqual(goal.period, period))

      if (goalToUpdate) {
        console.log('updating', goalToUpdate.title, period)
        goalToUpdate.period = period
        this.$store.dispatch('UPDATE_GOAL_PARTIALLY', { goalId: goalToUpdate.id, updatedFields: { period } })
      }
    },
  }
}
</script>

<style lang="scss">
  .ghost-goal-planner {
    opacity: 0.4;
  }

  .planner__goals-box {
    border-style: dashed;
    border-width: 2px;
    border-radius: 8px;
    border-color: rgba(112, 112, 112, 0.4);
    padding: 0.5rem 0.5rem 4rem 0.5rem;
  }

  .planner__goals-box.backlog {
    border-style: dashed;
    border-width: 2px;
    border-radius: 8px;
    border-color: rgba(112, 112, 112, 0.4);
    padding: 0.5rem 0.5rem 4rem 0.5rem;
    padding-bottom: 20rem
  }

  .planner__goals-box-with-title {
    margin-bottom: 2rem
  }

</style>
